export default __webpack_public_path__ + "static/credit-saint-521aae283ebf6107b94d1af263ad6dbb.svg";